// @ts-nocheck
import { useSelector } from 'react-redux';

const useAccess = () => {
    const permissions = useSelector(state => state.auth.user.roleNames || {});
    return (menuId, action) => permissions[menuId]?.includes(action);
};

export default useAccess;
